import service from '@/utils/server';
let modelPath = '/sm/smParam';
export const queryList = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post',
        data
    })
};
//
export const getAddSmParam = data => {
  return service({
    url: modelPath+'/add',
    method: 'post',
    data
  })
};

//
export const getUpdateSmParam = data => {
  return service({
    url: modelPath+'/update',
    method: 'post',
    data
  })
};

//
export const getDeleteSmParamList = data => {
  return service({
    url: modelPath+'/delete/'+data.id,
    method: 'post'
  })
};






// WEBPACK FOOTER //
// ./src/page/sm/smParam/api/index.js